import { Box } from '@mui/material';
import { Column, defaultColDef, CellParams } from '@qrios/frontend-library';

import { predefinedColumns } from '../../../../../../common/table/columns';

import StatusIcon from './status-icon';
import { OPERATION_DETAILS_EVENT_TYPE } from './interfaces';

export const statusIconRenderer = (cellParams: CellParams) => <StatusIcon type={cellParams.row.type} />;
export const logRenderer = (cellParams: CellParams) => {
  const { type }: { type: OPERATION_DETAILS_EVENT_TYPE } = cellParams.row;
  switch (type) {
    case OPERATION_DETAILS_EVENT_TYPE.VOICE_APP_RESPONSE: {
      return (
        <div>
          {cellParams.formattedValue.split('\n').map((line: string, index: number) => (
            <Box pb={0.25} key={index}>
              {line}
            </Box>
          ))}
        </div>
      );
    }
    default: {
      return cellParams.formattedValue;
    }
  }
};

export const columns: Column[] = [
  {
    field: 'statusIcon',
    headerName: '',
    renderCell: statusIconRenderer,
    width: 25,
    minWidth: 25
  },
  predefinedColumns.date({ sortable: true }),
  {
    ...defaultColDef,
    field: 'log',
    headerName: 'Log',
    renderCell: logRenderer,
    flex: 4
  }
];
